export function isCssVar(key) {
    return key.indexOf('--') === 0;
}
export function isJsonLike(value) {
    return typeof value === 'string' && value[0] === '{' && value.slice(-1) === '}';
}
export function parseJson(strValue) {
    return strValue.slice(1, -1)
        .split(',')
        .reduce(function (json, current) {
        var _a = current.split(':'), key = _a[0], value = _a[1];
        json[key.trim()] = value.trim().replace(/^["|'](.*)["|']$/, '$1');
        return json;
    }, {});
}
export function isNumber(value) {
    return typeof value === 'number';
}
export function forEach(obj, iteratee) {
    Object.keys(obj).forEach(function (key) { return iteratee(obj[key], key); });
}
export function pickBy(obj, predicate) {
    return Object.keys(obj || {}).reduce(function (result, key) {
        if (predicate(obj[key])) {
            result[key] = obj[key];
        }
        return result;
    }, {});
}
